/**
 *
 * FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE
 *
 */

import { Actions, ActionTypes } from "./actions";
import { getInitialState, State } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.fetch:
      return {
        ...state,
        fetchStatus: "loading",
        paymentCollection: undefined,
        error: undefined
      };
    case ActionTypes.fetchSuccess:
      return {
        ...state,
        fetchStatus: "success",
        paymentCollection: action.payload.paymentCollection,
        error: undefined
      };
    case ActionTypes.fetchError:
      return {
        ...state,
        fetchStatus: "failed",
        paymentCollection: undefined,
        error: action.payload.error
      };
    case ActionTypes.reset:
      return getInitialState();
    default:
      return state;
  }
};

export { reducer, getInitialState };
